/* OTS Fitness Collection Showcase — vanilla JS slider controls (no dependencies) */
(function () {
  'use strict';

  function initSlider(root) {
    var track = root;
    var wrapper = track.closest('.ots-fitness__full-width, .page-width');
    if (!wrapper) return;

    var prevBtn = wrapper.querySelector('[data-ots-fitness-prev]');
    var nextBtn = wrapper.querySelector('[data-ots-fitness-next]');
    var dotsContainer = wrapper.querySelector('[data-ots-fitness-dots]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('.ots-fitness__slide'));

    if (!slides.length) return;

    var autoplayEnabled = track.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = (parseFloat(track.getAttribute('data-autoplay-speed')) || 4) * 1000;
    var infinite = track.getAttribute('data-infinite') === 'true';
    var autoplayTimer = null;

    function isSliderMode() {
      return window.matchMedia('(max-width: 749px)').matches && track.getAttribute('data-mobile-layout') === 'slider';
    }

    function currentIndex() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var closestDist = Infinity;
      slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.offsetLeft - scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function scrollToIndex(index) {
      if (index < 0) index = infinite ? slides.length - 1 : 0;
      if (index >= slides.length) index = infinite ? 0 : slides.length - 1;
      var target = slides[index];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }

    function updateControls() {
      if (!isSliderMode()) return;
      var index = currentIndex();

      if (prevBtn) prevBtn.disabled = !infinite && index === 0;
      if (nextBtn) nextBtn.disabled = !infinite && index === slides.length - 1;

      if (dotsContainer) {
        Array.prototype.forEach.call(dotsContainer.children, function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }
    }

    function buildDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ots-fitness__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () {
          scrollToIndex(i);
        });
        dotsContainer.appendChild(dot);
      });
    }

    function startAutoplay() {
      if (!autoplayEnabled || autoplayTimer) return;
      autoplayTimer = window.setInterval(function () {
        if (!isSliderMode()) return;
        scrollToIndex(currentIndex() + 1);
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoplay();
        scrollToIndex(currentIndex() - 1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoplay();
        scrollToIndex(currentIndex() + 1);
        startAutoplay();
      });
    }

    buildDots();
    updateControls();

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(updateControls, 100);
    }, { passive: true });

    track.addEventListener('mouseenter', stopAutoplay);
    track.addEventListener('touchstart', stopAutoplay, { passive: true });

    window.addEventListener('resize', updateControls);

    startAutoplay();
  }

  function initAll() {
    var sliders = document.querySelectorAll('[data-ots-fitness-slider]');
    Array.prototype.forEach.call(sliders, initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var slider = event.target.querySelector('[data-ots-fitness-slider]');
    if (slider) initSlider(slider);
  });
})();
